const ENTITY_PAGE_SIZE = 5;
export default ENTITY_PAGE_SIZE;